export default __webpack_public_path__ + "static/media/lose@3x.528471be.png";